t = require('app/scripts/views/internal/teacup-with-helpers')('board_menu_activity')

module.exports = ->
  t.div '.segmented-control', =>
    t.a '.segmented-control-item.js-show-all.js-control-option', { href: '#' }, =>
      t.format 'all'
    t.a '.segmented-control-item.js-show-comments.js-control-option', { href: '#' }, =>
      t.format 'comments'

  t.div '.phenom-list.js-list-activity'

  t.a '.show-more.js-more-actions', { href: '#' }, =>
    t.format 'load-more-activity'
